<div class="seperator"></div>
<div class="title" mat-dialog-title>Enable Pinterest</div>
<div class="dialog-body">
    <div class="body-content">
        <div class="form-text">Please schedule two daily pinterest reports and send to below email: </div>
        <div class="ias-email">
            {{pinterestEmail}}
        </div>
        <div class="template">
        </div>
    </div>
</div>
<div class="dialog-footer">
    <div>
    </div>
</div>